import styled from 'styled-components';
import { FaGithub } from 'react-icons/fa';

export const Container = styled.header`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: var(--header);
  padding: 11px 16px;
`;

export const GithubLogo = styled(FaGithub)`
  fill: var(--logo);
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  transition: opacity 0.2s ease;
  cursor: pointer;

  &:hover {
    opacity: 0.85;
  }
`;

export const SearchForm = styled.form`
  padding-left: 16px;
  width: 100%;

  input {
    background: var(--search);
    color: var(--logo);
    outline: 0;
    border-radius: 6px;
    padding: 7px 12px;
    width: 100%;
    transition: width 0.2s ease-out, color 0.2s ease-out;

    &:focus {
      width: 318px;
    }
  }
`;
